const translations = {
    cancel: 'Cancel',
    email: 'Email',
    emailInvalid: 'Enter a valid email address.',
    noSeatsRemaining: 'Your organization has no seats remaining.',
    role: 'Role',
    save: 'Send Invitation',
    saving: 'Sending…',
    seatsRemaining: 'Seats Remaining',
    selectRole: 'Select a role',
    title: 'Invite User'
};

export default translations;
